<template>
  <div v-loading="loading">
    <div class="m-b-20 ovf-hd">
      <div class="fl" v-show="addShow">
        <router-link class="btn-link-large add-btn" to="add">
          <i class="el-icon-plus"></i>&nbsp;&nbsp;添加表单
        </router-link>
      </div>
			<div class="fl w-300 m-l-30" @keyup.enter="search()">
				<el-input v-model="keywords" placeholder="请输入表单名"></el-input>
			</div>
			<div class="fl m-l-20">
				<el-button type="primary" @click="search()">搜索</el-button>
			</div>
    </div>
    <el-table :data="tableData" style="width: 100%" @selection-change="selectItem">
      <el-table-column type="selection" width="50">
      </el-table-column>
      <el-table-column label="标识" prop="name">
      </el-table-column>
      <el-table-column label="名称" prop="title" width="200">
      </el-table-column>
      <el-table-column label="表描述" prop="des">
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time" width="200">
        <template scope="scope">
          <div>
            {{ scope.row.create_time | parseTime }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="数据库状态" prop="status" width="120" >
        <template scope="scope">
          <div>
            {{ scope.row.update_status | updateStatus }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="status" width="100">
        <template scope="scope">
          <div :class="{bad: scope.row.status == 0}">
            {{ scope.row.status | status }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300">
        <template scope="scope">
          <div>
            <span v-show="editShow" v-if="scope.row.is_system != 1">
              <router-link :to="{ name: 'modelEdit', query: { id: scope.row.id }}" class="btn-link edit-btn m-r-5">
            编辑
              </router-link>
            </span>
            <span v-show="deleteShow" v-if="scope.row.is_system != 1">
              <el-button size="small" @click="confirmDelete(scope.row)">删除</el-button>&nbsp;&nbsp;|&nbsp;
            </span>
            <span v-show="designShow">
              <el-button :plain="true" size="small" @click="design(scope.row.id, scope.row.name)">设计表</el-button>
              <!-- <router-link :to="{ name: 'modelDesign', query: { id: scope.row.id }}" class="btn-link edit-btn m-r-5"> -->
              <!-- 设计表 -->
              <!-- </router-link> -->
            </span>
            <span v-show="scope.row.update_status == 0">
              <el-button :plain="true" size="small" @click="beforeUpdateDatabase(scope.row.id)">更新表</el-button>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pos-rel p-t-20">
      <btnGroup :selectedData="multipleSelection" :type="'form/models'" need="status" :isUpdate="true" @setLoading="setLoading"></btnGroup>
      <div class="block pages">
        <el-pagination @current-change="handleCurrentChange" layout="prev, pager, next" :page-size="limit" :current-page="currentPage"
                       :total="dataCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog
        ref="updateDialog"
        title="提示"
        size="tiny"
        :before-close="handleClose">
      <span>是否更新此表？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeUpdateDialog">取 消</el-button>
        <el-button type="primary" @click="updateDatabase">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import btnGroup from '../Common/normal/btn-group.vue'
  import http from '../../assets/js/http'

  export default {
    data() {
      return {
        tableData: [],
        dataCount: null,
        currentPage: null,
        keywords: '',
        status: '',
        multipleSelection: [],
        statusOption: [
          {
            label: '启用',
            value: 1
          },
          {
            label: '禁用',
            value: 0
          }
        ],
        loading: false,
        limit: 15,
        updateId: ''
      }
    },
    filters: {
      parseTime(item) {
        return moment.unix(item).format('YYYY-MM-DD')
      },
      updateStatus(value) {
        return value == 0 ? '未更新' : '已更新'
      }
    },
    methods: {
      search() {
        router.push({ name: 'modelList', query: { keywords: this.keywords, page: 1, status: this.status }})
      },
      selectItem(val) {
        this.multipleSelection = val
      },
      handleCurrentChange(page) {
        router.push({ name: 'modelList', query: { keywords: this.keywords, page: page, status: this.status }})
      },
      confirmDelete(item) {
        this.$confirm('确认删除该模型?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.apiDelete('form/models/', item.id).then((res) => {
            if (res.code == 200) {
              _g.toastMsg(this, 'success', '删除成功')
              setTimeout(() => {
                _g.reloadPage(this)
              }, 1500)
            } else {
              _g.dealError(this, res)
            }
          })
        }).catch(() => {
        })
      },
      design(id, name) {
        router.push({ name: 'modelDesign', query: { id: id, name: name }})
      },
      closeUpdateDialog() {
        this.$refs.updateDialog.close()
      },
      beforeUpdateDatabase(id) {
        this.updateId = id
        this.$refs.updateDialog.open()
      },
      updateDatabase() {
        let postData = {
          model_id: [this.updateId]
        }
        this.closeUpdateDialog()
        this.loading = true
        this.apiPost('form/models/execute', postData).then((res) => {
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '更新成功')
            setTimeout(() => {
              _g.reloadPage(this)
            }, 1000)
          } else {
            _g.dealError(this, res)
          }
          this.loading = false
        })
      },
      setLoading(value) {
        this.loading = value
      },
      getAllModel() {
        this.loading = true
        let postData = {
          params: {
            keywords: this.keywords,
            limit: this.limit,
            page: this.currentPage,
            status: this.status
          }
        }
        this.apiGet('form/models', postData).then((res) => {
          this.loading = false
          if (res.code == 200) {
            this.tableData = res.data.list
            this.dataCount = res.data.dataCount
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getCurrentPage() {
        let data = this.$route.query
        if (data) {
          if (data.page) {
            this.currentPage = parseInt(data.page)
          } else {
            this.currentPage = 1
          }
        }
      },
      getKeywords() {
        let data = this.$route.query
        if (data) {
          if (data.keywords) {
            this.keywords = data.keywords
          } else {
            this.keywords = ''
          }
        }
      },
      init() {
        this.getKeywords()
        this.getCurrentPage()
        this.getAllModel()
      }
    },
    created() {
      this.init()
    },
    computed: {
      addShow() {
        return _g.getHasRule('')
      },
      editShow() {
        return _g.getHasRule('')
      },
      designShow() {
        return _g.getHasRule('')
      },
      deleteShow() {
        return _g.getHasRule('')
      }
    },
    watch: {
      '$route'(to, from) {               // 监听路由改变
        this.init()
      }
    },
    components: {
      btnGroup
    },
    mixins: [http]
  }

</script>
<style>
  .bad {
    color: #ff0000;
  }
</style>



// WEBPACK FOOTER //
// list.vue?55125f99